import React from 'react';
import { AppDataContext } from './AppDataContext';

export const withAppData = (Wrapped) =>
  class extends React.Component {
    render() {
      return (
        <AppDataContext.Consumer>
          {(ctx) => <Wrapped {...this.props} appData={ctx} />}
        </AppDataContext.Consumer>
      );
    }
  };
